var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as t from 'io-ts';
import axios from 'axios';
const TIMEOUT_MS = 3000;
const Consent = t.intersection([
    t.type({
        default: t.boolean,
        latest_version: t.type({
            id: t.string,
            content: t.intersection([
                t.type({
                    display_title: t.string,
                    description_text: t.string,
                    dialogue_text: t.string,
                    product_text: t.string,
                }),
                t.partial({
                    aria_label: t.string,
                    link: t.string,
                    link_text: t.string,
                }),
            ]),
        }),
        id: t.string,
    }),
    t.partial({
        /** if the country is not defined, the consent is valid for all countries */
        country: t.string,
        name: t.string,
    }),
]);
const BundleConsent = t.intersection([
    Consent,
    t.type({
        children_consents: t.array(Consent),
        is_bundle: t.boolean,
    }),
]);
const ConsentsV1Response = t.array(BundleConsent);
export const fetchConsentsV1 = (baseUrl, _a) => __awaiter(void 0, void 0, void 0, function* () {
    var { locale } = _a, params = __rest(_a, ["locale"]);
    const response = yield axios.get(`${baseUrl}/consumer-api/consents-router/v1/consents`, {
        headers: {
            'App-Language': locale,
        },
        params: Object.assign(Object.assign({}, params), { platform: 'web' }),
        timeout: TIMEOUT_MS,
    });
    if (!ConsentsV1Response.is(response.data)) {
        throw new Error('Could not decode consents');
    }
    return response.data;
});
